<template>
    <v-card>
        <v-card-title>
            Bar 
        </v-card-title>
        <v-card-text>
            
            <v-btn @click="$store.commit('setShowHelpEvent', true)">
                Show help
            </v-btn>
        </v-card-text> 
        <v-card-actions>
            <v-btn @click="$store.commit('setShowAnswerEvent',true)">Show answer</v-btn>
            <v-btn @click="$store.commit('setCheckAnswerEvent',true)">Check</v-btn>
            <v-btn @click="closeForm()">Close</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    data() {
        return {

        }
    },
    methods: {
        closeForm() {
            this.$router.push({name:'lesson_admin_content', params: { id: JSON.parse(localStorage.getItem('position')).activeLesson.id}})   
        }
    }
}
</script>